import {
  createPercepcionImpuesto,
  listAllPercepcionesImpuesto,
  softDeletePercepcionImpuesto,
  updatePercepcionImpuesto,
  type PercepcionImpuestoFields,
} from '@/shared/api/controllers/percepcionesImpuesto';
import { SimpleAbmEntity, type SimpleAbmAdapter } from '../../SimpleAbmEntity';
import type { EntityViewProps } from '../../types';

const adapter: SimpleAbmAdapter<PercepcionImpuestoFields> = {
  queryKey: ['configuracion', 'percepciones-impuesto'],
  abmKind: 'percepciones',
  listAll: listAllPercepcionesImpuesto,
  create: createPercepcionImpuesto,
  update: updatePercepcionImpuesto,
  softDelete: softDeletePercepcionImpuesto,
  valueOf: (i) => i.fields.PercepcionImpuesto_PI ?? '',
  statusOf: (i) => i.fields.Status_PI,
  fieldLabel: 'Percepción / Impuesto',
  fieldPlaceholder: 'Ingresar Percepción / Impuesto',
  entitySingular: 'percepción / impuesto',
  femenino: true,
  createdMessage: 'Percepción / impuesto creada correctamente.',
  updatedMessage: 'Percepción / impuesto actualizada correctamente.',
  deletedMessage: 'Percepción / impuesto eliminada correctamente.',
};

export function PercepcionesImpuestoEntity(props: EntityViewProps) {
  return <SimpleAbmEntity adapter={adapter} {...props} />;
}
